import { Dispatch } from 'redux';
import { getPoiList } from 'modules/api/lookups';
import { CancelFunctions } from 'components/common/types';
import { PoiOptionListResponse } from 'components/common/types/Planner.types';
import { changeDataProvidersWithPoiOptions } from './reducer';
import { transformDataProvidersWithPoiOptions } from './transformPoiOptions';

export const fetchAndSetPoiList =
  (cancelFunctions: CancelFunctions) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      const poiOptionsResponse: PoiOptionListResponse[] = await getPoiList(cancelFunctions);

      if (poiOptionsResponse.length) {
        dispatch(changeDataProvidersWithPoiOptions(transformDataProvidersWithPoiOptions(poiOptionsResponse)));
      }
      // eslint-disable-next-line no-empty
    } catch {}
  };
